'use strict';

class DatosFormController {
  constructor(DataService, Message, Storage) {
    'ngInject';
    this.DataService = DataService;
    this.Message = Message;
    this.Storage = Storage;
    this.user = Storage.getUser();
  }

  $onInit() {
  }

  $onChanges(changes) {
    if(changes.supervision&&changes.supervision.currentValue) {
      this.fiscal = this.supervision.proyecto.equipo_tecnico.find((u)=>{ return u.cargo==='CG_FISCAL'&&u.estado==='ACTIVO'; });
      this.fiscal.usuario.persona.telefono_ant = this.fiscal.usuario.persona.telefono;
      this.supervisor = this.supervision.proyecto.equipo_tecnico.find((u)=>{ return u.cargo==='CG_SUPERVISOR'&&u.estado==='ACTIVO'; });
      this.supervisor.usuario.persona.telefono_ant = this.supervisor.usuario.persona.telefono;
      this.empleados = this.supervision.proyecto.documentacion_exp.empleados;
      for (let i in this.empleados) {
        this.empleados[i].persona.telefono_ant = this.empleados[i].persona.telefono;
      }
      if (this.supervision.proyecto.documentacion_exp.datos_empresa.representante_legal) {
        this.repLegal = this.supervision.proyecto.documentacion_exp.datos_empresa.representante_legal;
        this.repLegal.cargo_actual_ant = this.repLegal.cargo_actual;
        this.repLegal.persona.telefono_ant = this.repLegal.persona.telefono;
      }
      /**************************************************************************************************************
       * Se adiciono el codigo 24/07/2024 para que se visualize el nombre del representante legal de una asocicion
       ***************************************************************************************************************/
      if (this.supervision.proyecto.documentacion_exp.datos_asociacion
        &&this.supervision.proyecto.documentacion_exp.datos_asociacion.nombre_asociacion
        &&this.supervision.proyecto.documentacion_exp.datos_asociacion.asociado.representante_legal) {
        this.repLegal.nombreCompleto=this.supervision.proyecto.documentacion_exp.datos_asociacion.asociado.representante_legal.nombreCompleto;
      }
      /*************************************************************************************************************/
      this.modoVista = this.supervision.estado_actual.atributos['computos']||this.supervision.estado_actual.atributos['informe'] ? false : true;
      this.descuento = this.supervision.estado_actual.atributos['informe'] ? true : false;
    }
  }

  // Representante legal
  updateCargoRep() {
    if (this.repLegal.cargo_actual_ant !== this.repLegal.cargo_actual || this.repLegal.persona.telefono_ant !== this.repLegal.persona.telefono) {
      this.DataService.put(`proyectos/${this.supervision.fid_proyecto}/empresa-representante`,this.repLegal).then((resp)=>{
        if (resp&&resp.finalizado) {
          this.repLegal.cargo_actual_ant = this.repLegal.cargo_actual;
          this.repLegal.persona.telefono_ant = this.repLegal.persona.telefono;
          this.Message.success(resp.mensaje);
        } else {
          this.Message.warning(resp.mensaje);
        }
      });
    }
  }

  // Empleados
  updatePhone(empleado) {
    if (empleado.persona.telefono_ant!==empleado.persona.telefono) {
      if (empleado.id_empleado) {
        empleado.persona.id_empleado = empleado.id_empleado;
        empleado.persona.cargo_actual = empleado.cargo_actual;
        this.DataService.put(`proyectos/${this.supervision.fid_proyecto}/empresa-empleados/${empleado.id_empleado}/telefono`,empleado.persona).then((resp)=>{
          if (resp&&resp.finalizado) {
            empleado.persona.telefono_ant=empleado.persona.telefono;
            this.Message.success(resp.mensaje);
          } else {
            empleado.persona.telefono=empleado.persona.telefono_ant;
            this.Message.warning(resp.mensaje);
          }
        });
      } else {
        this.DataService.put(`personas/${empleado.persona.id_persona}/telefono`,empleado.persona).then((resp)=>{
          if (resp&&resp.finalizado) {
            empleado.persona.telefono_ant=empleado.persona.telefono;
            this.Message.success(resp.mensaje);
          } else {
            empleado.persona.telefono=empleado.persona.telefono_ant;
            this.Message.warning(resp.mensaje);
          }
        });
      }
    }
  }

  updateText(form) {
    let datos = {
      form: form.$name,
    };
    if (form.$name==='form2') {
      datos.campo = 'dias_retraso';
      datos.texto = this.supervision.formulario.form2.dias_retraso;
    }
    if (form.$name==='form4') {
      datos.campo = 'descripcion';
      datos.texto = this.supervision.formulario.form4.descripcion;
    }
    if (form.$name==='form6') {
      datos.campo = 'resumen';
      datos.texto = this.supervision.formulario.form6.resumen;
    }
    if (datos.texto) {
      this.DataService.put(`supervisiones/${this.supervision.id_supervision}/formulario`,datos).then((resp)=>{
        if (resp&&resp.finalizado) {
          this.Message.success(resp.mensaje);
        }
      });
    }
  }

  updateForm(field) {
    let datos = {
      form: field.$$parentForm.$name,
      campo: field.$name,
      valor: field.$modelValue
    };
    this.DataService.put(`supervisiones/${this.supervision.id_supervision}/formulario`,datos).then((resp)=>{
      if (resp&&resp.finalizado) {
        this.Message.success(resp.mensaje);
      }
    });
  }

}

export default DatosFormController;



// WEBPACK FOOTER //
// ./src/app/components/empresas/planilla-proyecto/datos-form246/datos-form.controller.js